import React from "react";
import PropTypes from "prop-types";
import _EmailInput from "./_EmailInput";
const _EmailControl = (props) => {
  const { value, onChange, errors, name, title, required } = props;
  return (
    <div className="flex flex-col py-2 w-full">
      <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
        {title}
        {required && <span className="text-red-700 mx-1">*</span>}
      </label>

      <_EmailInput
        name={name}
        defaultValue={value}
        changeHandler={onChange}
        error={errors && errors[name] ? true : false}
      />

      {errors && errors[name] && (
        <span className="text-red-600 text-[14px] mt-2">{errors[name]}</span>
      )}
    </div>
  );
};

_EmailControl.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  name: PropTypes.string,
  title: PropTypes.string,
  required: PropTypes.bool,
};

export default _EmailControl;
